UC.views.AttorneyProfileCalendarAvailability = Backbone.View.extend({

  routes: {
    instant: '/users/{0}/scheduled_calls/instant',
    instant_availability: '/users/{0}/scheduled_calls/instant_availability',
    create_schedule_from_instant_reply: '/users/{0}/scheduled_calls/schedule_from_instant_reply',
    create_message: '/messages'
  },

  events: {
    'click #js-open-time-zone-change': 'openTimezoneChange',
    'click #js-close-time-zone-change': 'closeTimezoneChange',
    'focus #js-time-zones': 'focusTimeZone',
    'click .js-day': 'daySelected',
    'click .js-time': 'timeSelected',
    'click .js-switch-pages': 'switchPages',
    'click #js-submit': 'submitForm',
    'click #js-previous-available-days-link': 'previousAvailableDays',
    'click #js-next-available-days-link': 'nextAvailableDays',
    'click .js-previous-available-times-link': 'previousAvailableTimes',
    'click .js-next-available-times-link': 'nextAvailableTimes',
    'change #js-job': 'removeErrors',
    'submit form.js-send-message': 'submitMessageForm'
  },

  initialize: function () {
    this.route = UC.constants.attorneyViewing ?
                  this.routes.instant_availability :
                  this.routes.instant;
    this.goHam();
  },

  removeErrors: function() {
    this.$('.form-group').removeClass('has-error');
  },

  submitMessageForm: function(e) {
    e.preventDefault();
    var data = {};

    $($(e.currentTarget).serializeArray()).each(function(index, obj){
      data[obj.name] = obj.value;
    });
    
    UC.net.post(this.routes.create_message, data)
      .done(function(result) {
        if (result.result === 'success') {
          UC.utils.showNotification('Successfully Sent Message.', UC.constants.results.success);
          window.location = '/messages';
        } else
          UC.utils.showNotification(result.message, UC.constants.results.failure);
      })
  },

  switchPages: function (e) {
    if ($(e.currentTarget).hasClass('disabled')) return;
    var $job = this.$('#js-job');

    if ($job.val().isBlank()) {
      UC.utils.showValidationErrors([{
        element: $job,
        text: 'Please select a job.',
        className: 'form-group'
      }]);
      return false
    }
    // UC.utils.recordKissEvent('schedule instant call - clicked ' + $(e.currentTarget).text() + ' btn', this.standardKissData());

    this.$('#js-select-time-page').toggleClass('hidden');
    this.$('#js-confirm-time-page').toggleClass('hidden');
  },

  setSelectTimeHeader: function (day) {
    var text = (day) ? 'Select a time on ' + day : 'Select a time';
    this.$('#js-select-a-time-header').text('2. ' + text);
    this.$('#js-select-a-day-text').toggleClass('hidden', !!day);
  },

  goHam: function () {
    UC.net.get(this.route.format(UC.constants.attorneyId), {
      job_id: UC.constants.jobId,
      is_modal: false,
      jobs: UC.constants.jobs })
    .done(function (res) {
      this.$('.js-call-container').removeClass('hidden');
      if (res.availability) {
        this.render(res.html);
      } else {
        this.$('.js-no-availability').removeClass('hidden');
      }
    }.bind(this))
    .always(function () {
      if (this.hamCallback) this.hamCallback();
    }.bind(this));
  },

  nextAvailableDays: function (e) {
    e.preventDefault();
  
    // UC.utils.recordKissEvent('schedule instant call - clicked next available days', this.standardKissData());
  
    var lastVisibleIndex = this.$('.js-day:not(.btn-hidden):last').data('index');
    var nextVisible = this.$('.js-day').slice(lastVisibleIndex + 1, lastVisibleIndex + 4);
    $('.js-day').addClass('btn-hidden');
    $(nextVisible).removeClass('btn-hidden');
  
    this.toggleDayPaginationLinks();
  },

  previousAvailableDays: function (e) {
    e.preventDefault();
  
    // UC.utils.recordKissEvent('schedule instant call - clicked previous available days', this.standardKissData());
  
    var firstVisibleIndex = this.$('.js-day:not(.btn-hidden):first').data('index');
    var nextVisible = this.$('.js-day').slice(firstVisibleIndex - 3, firstVisibleIndex);
    $('.js-day').addClass('btn-hidden');
    $(nextVisible).removeClass('btn-hidden');
  
    this.toggleDayPaginationLinks();
  },

  toggleDayPaginationLinks: function () {
    var showingFirstDays = this.$('.js-day:not(.btn-hidden):first').data('index') == 0;
    $('#js-previous-available-days-text').toggleClass('hidden', !showingFirstDays);
    $('#js-previous-available-days-link').toggleClass('hidden', showingFirstDays);
  
    var showingLastDays = this.$('.js-day:not(.btn-hidden):last').data('index') + 1 >= $('.js-day').length;
  
    $('#js-next-available-days-text').toggleClass('hidden', !showingLastDays);
    $('#js-next-available-days-link').toggleClass('hidden', showingLastDays);
  },

  previousAvailableTimes: function (e) {
    e.preventDefault();
  
    // UC.utils.recordKissEvent('schedule instant call - clicked previous available times', this.standardKissData());
  
    var $currentTimesContainer = this.$('.js-times:not(.hidden)');
    var $timeElements = $currentTimesContainer.find('.js-time');
    var firstVisibleIndex = $timeElements.filter(':not(.btn-hidden):first').data('index');
    var nextVisible = $timeElements.slice(firstVisibleIndex - 6, firstVisibleIndex);
  
    $timeElements.addClass('btn-hidden');
    $(nextVisible).removeClass('btn-hidden');
  
    this.toggleTimePaginationLinks($currentTimesContainer);
  },

  nextAvailableTimes: function (e) {
    e.preventDefault();
  
    // UC.utils.recordKissEvent('schedule instant call - clicked next available times', this.standardKissData());
  
    var $currentTimesContainer = this.$('.js-times:not(.hidden)');
  
    var $timeElements = $currentTimesContainer.find('.js-time');
    var lastVisibleIndex = $timeElements.filter(':not(.btn-hidden):last').data('index');
    var nextVisible = $timeElements.slice(lastVisibleIndex + 1, lastVisibleIndex + 7);
    $timeElements.addClass('btn-hidden');
    $(nextVisible).removeClass('btn-hidden');
  
    this.toggleTimePaginationLinks($currentTimesContainer);
  },

  toggleTimePaginationLinks: function ($container) {
    var $timeElements = $container.find('.js-time');
  
    var showingFirstTimes = $timeElements.filter(':not(.btn-hidden):first').data('index') == 0;
  
    $container.find('.js-previous-available-times-text').toggleClass('hidden', !showingFirstTimes);
    $container.find('.js-previous-available-times-link').toggleClass('hidden', showingFirstTimes);
  
    var showingLastTimes = $timeElements.filter(':not(.btn-hidden):last').data('index') + 1 >= $timeElements.length;
  
    this.$('.js-times').find('.js-next-available-times-text').toggleClass('hidden', !showingLastTimes);
    this.$('.js-times').find('.js-next-available-times-link').toggleClass('hidden', showingLastTimes);
  },

  resetTimes: function (index) {
    var $container = this.$('.js-times[data-index="' + index + '"]');
    $container.find('.js-time').addClass('btn-hidden');
    $container.find('.js-time').slice(0, 6).removeClass('btn-hidden');
  
    this.toggleTimePaginationLinks($container);
  
    this.$('.js-next').addClass('hidden');
  
    this.$('.js-time').removeClass('btn-primary').removeClass('js-time-selected').addClass('btn-default-outline');
  },


  daySelected: function (e) {
    var $button = $(e.currentTarget);
    var index = $button.data('index');
  
    this.resetTimes(index);
  
    this.$('.js-times').addClass('hidden');
  
    if ($button.hasClass('js-day-selected')) {
      $button.removeClass('js-day-selected');
    
      this.setSelectTimeHeader();
    
    } else {
      this.$('.js-day').removeClass('js-day-selected');
      $button.addClass('js-day-selected');
    
      this.setSelectTimeHeader($button.data('dateShort'));
    
      this.$('.js-times').addClass('hidden');
      this.$('.js-times[data-index="' + index + '"]').removeClass('hidden');
    }
  
    this.$('.js-day').removeClass('btn-primary').addClass('btn-default-outline');
    this.$('.js-day-selected').addClass('btn-primary').removeClass('btn-default-outline');
  },

  timeSelected: function (e) {
    $button = $(e.currentTarget);
  
    if ($button.hasClass('js-time-selected')) {
      $button.removeClass('js-time-selected');
      this.$('.js-next').addClass('hidden');
    } else {
      this.$('.js-time').removeClass('js-time-selected');
      $button.addClass('js-time-selected');
    
      this.$('.js-next').removeClass('hidden');
    
      this.$('#js-scheduled-date-time-epoch').val($button.data('datetimeEpoch'));
      this.$('#js-scheduled-date-time').val($button.data('datetimeRaw'));
    
      this.$('.js-selected-day-time').text($button.data('datetimeLong'));
    }
  
    this.$('.js-time').removeClass('btn-primary').addClass('btn-default-outline');
    this.$('.js-time-selected').addClass('btn-primary').removeClass('btn-default-outline');
  },

  serializeForm: function () {
    var data = {
      time_zone: this.$('#js-time-zone').val(),
      message: this.$('#js-message').val(),
      phone: this.$('#js-phone-number').val(),
      ScheduledDateTime: this.$('#js-scheduled-date-time').val(),
      job_id: this.$('#js-job').val()
    };
  
    return data;
  },

  validate: function () {
    var errors = [];
  
    var $phone = this.$('#js-phone-number');
  
    if ($phone.val().isBlank()) {
      errors.push({
        element: $phone,
        text: 'Please enter your preferred phone number',
        className: 'form-group'
      });
    }
  
    var $message = this.$('#js-message');
    if ($message.val().isBlank()) {
      errors.push({
        element: $message,
        text: 'Please include a message',
        className: 'form-group'
      });
    }
  
    if (errors.length > 0) {
      UC.utils.showValidationErrors(errors);
      return false;
    } else {
      return true;
    }
  },

  openTimezoneChange: function (e) {
    e.preventDefault();
  
    this.$('#js-change-time-zone, #js-open-time-zone-change').toggleClass('hidden');
  },

  closeTimezoneChange: function (e) {
    e.preventDefault();
  
    this.$('#js-change-time-zone, #js-open-time-zone-change').toggleClass('hidden');
  },

  focusTimeZone: function(e) {
    var $selectDropdown = $(e.currentTarget);
    var previousValue = $selectDropdown.val();

    $selectDropdown.on('change', function(e) {
      this.changeTimeZone(e, previousValue)
    }.bind(this))
    
  },
  
  changeTimeZone: function (e, previousValue) {
    e.preventDefault();
    var $job = this.$('#js-job');
    var error = [];

    if ($job.val() === '') {
      error.push({
        element: $job,
        text: 'Please select a job before changing time zone.',
        className: 'form-group'
      });
      UC.utils.showValidationErrors(error);
      $(e.currentTarget).val(previousValue);
      return false
    }

    var data = {
      time_zone: this.$('#js-time-zones').val(),
      job_id: this.$('#js-job').val(),
      jobs: UC.constants.jobs,
      is_modal: false,
      time_zone_change: true
    };

    UC.net.get(this.route.format(UC.constants.attorneyId), data, function (res) {
      this.$('#js-instant-scheduler-container').replaceWith(res.html)
    }.bind(this));

  },

  submitForm: function (e) {
    e.preventDefault();
    if (!this.validate()) return;
  
    this.loader.showLoader();
    this.$switchPageBtns.addClass('disabled');
  
    var data = this.serializeForm();
  
    var time_till_call = this.$('#js-scheduled-date-time-epoch').val() - this.$('.modal-dialog').data('modalOpenedAt');
    // UC.utils.recordKissEvent('schedule instant call - scheduled ',
    //   $.extend(this.standardKissData(), {scheduled_time: data.ScheduledDateTime, time_till_call: time_till_call})
    // );
  
    UC.net.post(this.routes.create_schedule_from_instant_reply.format(UC.constants.attorneyId), data)
      .done(function (result) {
        UC.utils.showNotification(result.message, UC.constants.results.success);
        this.$('#js-confirm-time-page').toggleClass('hidden');
        this.$('#js-confirmation-page').toggleClass('hidden');
      }.bind(this))
      .always(function () {
        this.loader.hideLoader();
        this.$switchPageBtns.removeClass('disabled');
      }.bind(this));
  },

  standardKissData: function () {
    return {
      bid_id: this.bidId,
      job_id: UC.job.id
    };
  },

  render: function (html) {
  
    this.setSelectTimeHeader();
  
    this.loader = this.$('#js-submit').buttonLoader();
    this.$switchPageBtns = this.$('.js-switch-pages');

    $('.js-instant-call').html(html);
  }
});
